import { create } from 'zustand';

function readPersisted(key: string, fallback: string): string {
  try {
    return localStorage.getItem(key) ?? fallback;
  } catch {
    return fallback;
  }
}

export type ThemeMode = 'light' | 'dark' | 'system' | 'high-contrast';

interface UiState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  themeMode: ThemeMode;
  setThemeMode: (mode: ThemeMode) => void;
  focusMode: boolean;
  toggleFocusMode: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  sidebarCollapsed: readPersisted('sidebar_collapsed', 'false') === 'true',
  toggleSidebar: () =>
    set((s) => {
      const next = !s.sidebarCollapsed;
      try {
        localStorage.setItem('sidebar_collapsed', String(next));
      } catch {
        /* ignore */
      }
      return { sidebarCollapsed: next };
    }),

  themeMode: readPersisted('theme_mode', 'light') as ThemeMode,
  setThemeMode: (mode: ThemeMode) => {
    try {
      localStorage.setItem('theme_mode', mode);
    } catch {
      /* ignore */
    }
    set({ themeMode: mode });
  },

  focusMode: false,
  toggleFocusMode: () => set((s) => ({ focusMode: !s.focusMode })),
}));
